import { Theme } from "../styles/theme";
import * as echarts from "echarts";

export const calculateMinMove = (openValue: number) => {
  const conditions = [
    { threshold: 1000, move: 1 },
    { threshold: 100, move: 0.5 },
    { threshold: 1, move: 0.1 },
    { threshold: 0.1, move: 0.001 },
    { threshold: 0.01, move: 0.001 },
    { threshold: 0.001, move: 0.0001 },
    { threshold: 0.0001, move: 0.00001 },
    { threshold: 0.00001, move: 0.000001 },
    { threshold: 0.00001, move: 0.000001 },
    { threshold: 0.000001, move: 0.0000001 },
  ];

  const matchingCondition = conditions.find(condition => openValue > condition.threshold);
  return matchingCondition ? matchingCondition.move : 0;
};
type EChartsOption = echarts.EChartsOption;
export const getChartOptions = (theme: Theme, chartData: Array<Array<number>>): EChartsOption => {
  const option: EChartsOption = {
    animation: false,
    tooltip: {
      show: false,
    },
    axisPointer: {
      show: true,
      snap: true,
      label: {
        margin: 0,
        fontFamily: "Work Sans",
        color: theme.font.primary.default,
        backgroundColor: theme.theme["900"],
      },
      lineStyle: {
        color: theme.theme["900"],
      },
    },
    grid: {
      show: false,
      bottom: "11%",
      left: "0",
      right: "0",
      height: "95%",
    },
    xAxis: {
      axisPointer: {
        label: {
          align: "left",
          padding: [4, 0, 4, 4],
          formatter: params => {
            const date = new Date(params.value);
            let hours = date.getHours();
            const minutes = date.getMinutes();
            const ampm = hours >= 12 ? "pm" : "am";
            hours = hours % 12 || 12;
            const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;
            return `${hours}:${formattedMinutes}${ampm}`;
          },
        },
      },
      show: true,
      type: "time",
      splitNumber: 2,
      axisLine: {
        show: true,
        lineStyle: {
          color: theme.font.tertiary.default,
          width: 1,
        },
      },
      axisTick: {
        show: false,
      },
      axisLabel: {
        color: theme.font.secondary.default,
        fontFamily: "Work Sans",
        overflow: "break",
        hideOverlap: true,
        showMaxLabel: true,
        showMinLabel: false,
        inside: false,
        margin: 3,
        align: "left",
        formatter: value => {
          const date = new Date(value);
          const hours = date.getHours();
          const ampm = hours >= 12 ? "pm" : "am";
          const formattedHours = hours % 12 || 12; // Convert 24h to 12h format and handle midnight
          return `${formattedHours}${ampm}`;
        },
      },
    },
    yAxis: {
      position: "right",
      show: false,
      type: "value",
      scale: true,
      axisPointer: {
        label: {
          align: "center",
          padding: 4,
        },
      },
      splitArea: {
        show: false,
      },
    },
    series: {
      type: "candlestick",
      data: chartData,
      itemStyle: {
        color: theme.font.price.up,
        color0: theme.font.price.down,
        borderColor: undefined,
        borderColor0: undefined,
      },
      barWidth: 3,
    },
  };
  return option;
};
